/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Editor_RedoInputs */

const en_common_editor_redo = /** @type {(inputs: Common_Editor_RedoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redo`)
};

const zh_common_editor_redo = /** @type {(inputs: Common_Editor_RedoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重做`)
};

/**
* | output |
* | --- |
* | "Redo" |
*
* @param {Common_Editor_RedoInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_editor_redo = /** @type {((inputs?: Common_Editor_RedoInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Editor_RedoInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_editor_redo(inputs)
	return zh_common_editor_redo(inputs)
});
export { common_editor_redo as "common.editor.redo" }